import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DynamicBreadcrumbService } from '@shared/services/dynamic-breadcrumb.service';
import { DynamicBreadcrumb } from '@shared/utilities/dynamic-breadcrumb';
import { Subject, Subscription, takeUntil, map } from 'rxjs';

@Component({
    selector: 'app-dynamic-breadcrumb',
    templateUrl: './dynamic-breadcrumb.component.html',
    styleUrl: './dynamic-breadcrumb.component.scss',
    standalone: false
})
export class DynamicBreadcrumbComponent implements OnInit, OnDestroy {
  @Input() breadcrumbs?: DynamicBreadcrumb[];
  @Input() bgColor = '#eee';
  @Input() fontSize = '18px';
  @Input() fontColor = '#0275d8';
  @Input() lastLinkColor = '#000';
  @Input() symbol = ' / ';
  
  private destroy$ = new Subject<void>();

  constructor(private dynamicBreadcrumbService: DynamicBreadcrumbService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (!this.breadcrumbs) {
      // this.breadcrumbs = this.dynamicBreadcrumbService.getCurrentBreadcrumbs();
      
      this.dynamicBreadcrumbService.breadcrumbs$
      .pipe(takeUntil(this.destroy$),
        map(breadcrumbs => {
          if (!breadcrumbs || breadcrumbs.length === 0) {
            return [];
          }
          if (breadcrumbs[0] === null || breadcrumbs[0] === undefined) {
            return [];
          }
          return breadcrumbs;
        })
      )
      .subscribe({
        next: (breadcrumbs) => {
        this.breadcrumbs = breadcrumbs;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error in breadcrumb subscription:', error);
        this.breadcrumbs = [];
        this.cdr.markForCheck();
      }
    });
    }
  }
  
  ngOnDestroy(): void {    
    this.destroy$.next();
    this.destroy$.complete();
  }
}
